import { inject } from "../../../../../lib/itn-ui-kit/services/service-container";

export function useViewDocumentsPermissions() {
  const currentUserService = inject("current-user-service");
  const permissions = currentUserService?.userRoles?.permissions ?? [];

  const canExportAllDocuments = permissions.includes("casemanager.can_export_all_documents");

  const canChangeDocument = permissions.includes("filemanager.change_document");
  const canDeleteDocument = permissions.includes("filemanager.delete_document");
  const canAddAssociation = permissions.includes("filemanager.add_document_association");

  const canCheckDocuments = permissions.includes("filemanager.check_document");
  const canViewCheckCheckbox = permissions.includes("utilities.can_view_check_documents_button");
  const canApproveDocuments = permissions.includes("filemanager.change_documentapproval");
  const canViewApprovalCheckbox = permissions.includes(
    "utilities.can_view_approve_documents_button"
  );

  return {
    canExportAllDocuments,
    canChangeDocument,
    canDeleteDocument,
    canAddAssociation,
    canCheckDocuments,
    canViewCheckCheckbox,
    canApproveDocuments,
    canViewApprovalCheckbox,
  };
}
